<template>
  <header id="u-client-header" class="has-border-bottom">
    <ribbon class="is-stretched">
      <u-padding class="is-paddingless-y is-spaced-apart">
        <brand-logo :to="{ name: 'clientDashboard' }" fallback="text" />
        <div class="u-client-header-controls">
          <slot />
        </div>
      </u-padding>
    </ribbon>
  </header>
</template>

<script>
export default {
  name: "ClientHeader",
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  }
};
</script>

<style lang="scss" scoped>
header#u-client-header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  height: 4.5rem;
  width: 100%;
  z-index: 10;
  background: $white;
  .u-client-header-controls {
    display: flex;
    align-items: center;
  }
}
</style>
